export const sizes = {
  container: {
    lg: '1350px',
    xl: '1432px',
  },
};
